// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u7id","newExpiryDate":"styles_newExpiryDate__NGM5u","footer":"styles_footer__2TdyN"};